/* eslint-disable  react/display-name */
import { Button, Grid, IconButton, Tooltip,CircularProgress } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import CloseIcon from "@mui/icons-material/Close";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import API from "../../../utils/API";
import BulkImport from "./BulkImport";
import { SyncUtils } from "../../../utils/SyncUtils";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function InventoryAdjustmentMultipleItem(props) {
  const { t } = useTranslation();
  const translate = t;
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [description, setDescription] = useState(null);
  const [descriptionError, setDescriptionError] = useState(null);
  const [reasonOptions, setReasonOptions] = useState();
  const [openWindow, setOpenWindow] = useState(false);
  const [mode, setMode] = useState("");
  const [items, setItems] = useState([]);
  const [prodLookupValue, setProdLookupValue] = useState();
  const [openFileDropWindow, setOpenFileDropWindow] = useState(false);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [stockChangeType, setStockChangeType] = useState({
    name: "Stock Add",
    code: "STOCK_ADD",
  });
  const [stockChangeTypeOptions, setStockChangeTypeOptions] = useState([
    {
      name: "Opening Stock",
      code: "OPENING_STOCK",
    },
    {
      name: "Stock Add",
      code: "STOCK_ADJUSTMENT_ADD",
    },
    {
      name: "Stock Remove",
      code: "STOCK_REMOVE",
    },
  ]);
  const [isSaveLoaderEnabled, setIsSaveLoaderEnabled] = useState(false);
  const [saveLabel, setSaveLabel] = useState("POST");
  const [origObject, setOrigObject] = useState(null);

  const REST_API_PAYLOAD_LIMIT = 1000000; //Maximum rows to send in single request

  useEffect(() => {
    if (origObject) {
      setWindowTitile(origObject.orderId);
    }
  }, [origObject]);

  useEffect(() => {
    setReasonOptions([
      { name: "Opening Stock", code: "Opening Stock" },
      { name: "Damage", code: "Damage" },
      { name: "Adjustment", code: "Adjustment" },
      { name: "Return", code: "Return" },
      { name: "Stock Take", code: "Stock Take" },
      { name: "Others", code: "Others" },
    ]);
  }, []);

  props.biRef.multipleItemAdjustment = {
    showInventoryAdjustmentMultipleItem: showInventoryAdjustmentMultipleItem,
  };

  async function showInventoryAdjustmentMultipleItem(origBeanId) {
    if (origBeanId) {
      populateOrigBean(origBeanId);
      // console.log(origObject.orderId);
      setMode("edit");
    } else {
      setMode("create");
      setWindowTitile("STOCK ADJUSTMENT");
      refreshScreen();
    }

    setSaveLabel("POST");
    setOpenWindow(true);
  }

  function refreshScreen() {
    loadRecordsFromCache(true);
    setDescriptionError(null);
    setDescription("");
    setOrigObject(null);
    setIsSaveLoaderEnabled(false);
    setStockChangeType({
      name: "Stock Add",
      code: "STOCK_ADD",
    });
  }

  async function populateOrigBean(origBeanId) {
    try {
      let { data } = await API.get(
        "/api/v1/inventory/adjustment/" + origBeanId
      );
      populateData(data);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate("Not able to retrive inventroy adjustment data from server")
      );
    }
  }

  async function getStock(id) {
    let search = { and: [], or: [] };
    search.and.push({
      op: "eq",
      key: "productId",
      value: id,
    });

    let sort = {
      id: "name",
      sortOrder: "ASC",
    };

    let { data } = await API.get(
      "/e_search/products?range=" +
        encodeURIComponent("[0,10]") +
        "&filter=" +
        encodeURIComponent(JSON.stringify(search)) +
        "&sort=" +
        encodeURIComponent(JSON.stringify(sort))
    );
    console.log(" Stock Search", data);
    if (data.data.length > 0) {
      return data.data[0].currentStock;
    }
    return 0;
  }

  async function populateData(bean) {
    setOrigObject(bean);
    setDescription(bean.description);
    setStockChangeType({
      name: bean.stockChangeTypeString,
      code: bean.stockChangeTypeCode,
    });

    let data = [];
    for (let i = 0; i < bean.adjustmentItemList.length; i++) {
      let item = bean.adjustmentItemList[i];
      //TODO Stock

      let dbProduct = await db.product
        .where("id")
        .equals(item.productId)
        .toArray();

      let currentStock = await getStock(item.productId);
      let adjustmentLineItem = [
        { v: i + 1 },
        { v: dbProduct.length == 0 ? null : dbProduct[0].name },
        { v: currentStock },
        { v: item.updatedQuantity },
        { v: { name: item.reason, code: item.reasonCode } }, //Stock change Reason
        {
          info: {
            productBean: dbProduct.length == 0 ? null : dbProduct[0],
            barcode: null,
          },
        },
      ];
      data.push(adjustmentLineItem);
    }
    setItems(data);
  }

  async function loadRecordsFromCache(isClearListEnable) {
    let inventoryAdjBulkImportDb = await db.inventoryAdjBulkImport.toArray();
    let updatedTableRows = [];
    if (inventoryAdjBulkImportDb.length > 0) {
      let sn = 1;
      for (let rowItem of inventoryAdjBulkImportDb) {
        //rowItem.payload[5].v = "PENDING";
        rowItem.payload[0].v = sn;
        updatedTableRows.push(rowItem.payload);
        sn++;
      }
      setItems(updatedTableRows);
    } else if (isClearListEnable) {
      setItems([]);
    }
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete order id") +
        " :" +
        origObject.orderId +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      action: "delete",
    });
  }

  async function onSave() {
    if (validate()) {
      setConfirmOpen(true);
      setConfirmContext({
        title: translate("Are You Sure"),
        message: translate(
          "Are you sure to proceed, This action can not be undone!"
        ),
        type: "warning",
        open: true,
        yes: true,
        no: true,
        action: "save",
      });
    }
  }

  async function handleSaveDraftClicked() {
    if (validate()) {
      saveData("DRAFT");
    }
  }

  function validate() {
    if (!description || description === "") {
      props.showMessage("error", translate("Validation failed"));
      setDescriptionError(translate("Description is required"));
      return false;
    }
    if (items.length < 1) {
      props.showMessage(
        "error",
        translate("Please add products before proceed")
      );
      return false;
    }
    for (let i = 0; i < items.length; i++) {
      if (
        items[i][3].v == null ||
        items[i][3].v == undefined ||
        items[i][3].v === ""
      ) {
        props.showMessage(
          "error",
          "New stock value is wrong at row: " + (i + 1)
        );
        return false;
      }
      if (!items[i][4].v || !items[i][4].v.code || items[i][4].v.code === "") {
        props.showMessage(
          "error",
          "Stock change reason wrong at row: " + (i + 1)
        );
        return false;
      }
    }
    return true;
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function saveData(status) {
    try {
      var payload = createPayload(status);
      let totalItems = items.length;
      let processedRecords = 0;
      let failedRecords = 0;
      showProgress(true, "Saving");
      for (let item of payload) {
        await API.post("/api/v1/inventory/adjustment", item).then(
          (response) => {
            processedRecords += item.adjustmentItemList.length;
            setSaveLabel(processedRecords + "/" + totalItems);
            if (item != null) {
              let barcodes = [];
              for (let batchItem of item.adjustmentItemList) {
                if (batchItem.barcode) barcodes.push(batchItem.barcode);
              }
              if (barcodes.length > 0)
                db.table("inventoryAdjBulkImport").bulkDelete(barcodes);
            }
          },
          (err) => {
            failedRecords += item.adjustmentItemList.length;
            console.log("ERROR", err);
          }
        );
       
      }
      if (failedRecords > 0) {
        props.showMessage(
          "error",
          failedRecords + " out of " + totalItems + " failed"
        );
        if (failedRecords !== totalItems) setOrigObject(null);
        loadRecordsFromCache(false);
      } else {
        props.showMessage("success", translate("Stock updated sucessfully"));
        setDescriptionError(null);
        setDescription("");
        setOrigObject(null);
        loadRecordsFromCache(true);
      }

      setIsSaveLoaderEnabled(false);
      setSaveLabel("POST");
      if (props.onRefreshList) props.onRefreshList();
      showProgress(false, "Saving");
    } catch (err) {
      showProgress(false, "Saving");
      props.showMessage("error", translate("Someting went wrong while save"));
      console.log("ERROR", err);
    }
  }

  async function onYesNoClicked(context, value) {
    let action = context.action;
    setConfirmOpen(false);

    if (value == "yes" && action === "save") {
      setIsSaveLoaderEnabled(true);
      saveData("POSTED");
    }

    if (value == "yes" && action === "delete") {
      try {
        let result = await API.delete(
          "/api/v1/inventory/adjustment/" + origObject.id
        );
        props.showMessage(
          "warning",
          translate("order Id") +
            " " +
            origObject.orderId +
            " " +
            translate("got Removed")
        );
        // props.onRefresh();
        props.onRefreshList();
        setOpenWindow(false);
      } catch (err) {
        console.log(err);
        props.showMessage("error", translate("Not able to Delete order"));
      }
    }
  }

  function createPayload(status) {
    try {
      //db.table("inventoryAdjBulkImport").clear();
      let payload = [];
      let itemsTemp = [...items];
      let batchCount = Math.ceil(itemsTemp.length / REST_API_PAYLOAD_LIMIT);
      for (let i = 1; i <= batchCount; i++) {
        let lastIndex =
          itemsTemp.length > REST_API_PAYLOAD_LIMIT
            ? REST_API_PAYLOAD_LIMIT
            : itemsTemp.length;
        let batch = itemsTemp.splice(0, lastIndex);
        let saveObject = Object.create(null);
        if (origObject) {
          saveObject = origObject;
        } else {
          saveObject["id"] = null;
          saveObject["intVersion"] = 0;
          saveObject["orderId"] = "AUTO";
        }

        saveObject["status"] = status;
        saveObject["description"] = description;
        saveObject["stockChangeTypeString"] = stockChangeType.name;
        saveObject["stockChangeTypeCode"] = stockChangeType.code;

        let selectedItems = [];
        batch.map((value) => {
          let itemsObject = Object.create(null);
          //itemsObject["productBean"] = value[5].info.productBean;
          //itemsObject["productBean"]["stockBean"] = null;
          itemsObject["productId"] = value[5].info.productBean.id;
          itemsObject["currentQuantity"] = value[2].v;
          itemsObject["updatedQuantity"] = value[3].v;
          itemsObject["reasonCode"] = value[4].v.code;
          itemsObject["reason"] = value[4].v.name;
          itemsObject["barcode"] = value[5].info.barcode;
          //itemsObject["status"] = value[5].v;
          selectedItems.push(itemsObject);
        });
        saveObject["adjustmentItemList"] = selectedItems;
        payload.push(saveObject);
      }
      return payload;
    } catch (error) {
      console.log("ERROR", error);
      return null;
    }
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.unitType}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.price}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };
  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  function getItemIndex(productId, itemList) {
    let index = null;
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i][5].info.productBean.id == productId) {
        index = i;
        break;
      }
    }
    return index;
  }
  async function addProductToTable(productBean, pricingBean) {
    var data = [...items];
    let itemIndex = getItemIndex(productBean.id, data);
    if (itemIndex == null) {
      //TODO Stock

      let currentStock = await getStock(productBean.id);
      //if (stockData.length > 0) currentStock = stockData[0].currentStock;

      let sn = data.length + 1;
      let item = [
        { v: sn },
        { v: productBean.name },
        { v: currentStock },
        { v: 0 },
        { v: null }, //Stock change Reason
        //{ v: "PENDING" },
        {
          info: {
            productBean: productBean,
            barcode: null,
          },
        },
      ];
      data.push(item);
      setItems(data);
    } else {
      props.showMessage("warning", translate("Product alredy exists"));
    }
  }

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let data = [...tableMeta.tableData];
    let barcodeToRemove = data[tableMeta.rowIndex][5].info.barcode;
    data.splice(tableMeta.rowIndex, 1);
    if (tableMeta.rowIndex != tableMeta.tableData.length - 1) {
      for (let i = tableMeta.rowIndex; i < data.length; i++) {
        data[i][0].v = data[i][0].v - 1;
      }
    }
    setItems(data);
    if (barcodeToRemove != null)
      db.table("inventoryAdjBulkImport").delete(barcodeToRemove);
  }

  async function getOptionsAsync(inputValue, callback) {
    let arr = await SyncUtils.searchInCache(
      props.productCache,
      inputValue,
      100
    );
    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );
    return callback([]);
  }

  const productLookupChanged = (newValue) => {
    prodSelected(newValue);
  };

  async function prodSelected(newValue) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(
      newValue.value
    );
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modifed, please Reload the Window");
    } else {
      addProductToTable(prodBean, pricingBean);
    }
    setProdLookupValue({ label: null, value: null });
  }

  function updateData(eventSource, meta, value, index) {
    if (eventSource === "table") {
      var data = [...items];
      data[meta.rowIndex][meta.columnIndex] = value;
      setItems(data);
    }
  }

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productName",
      label: translate("Product Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 260 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "stock",
      label: translate("Current Stock"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 20 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "newStock",
      label: translate("New Stock"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 80 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "reason",
      label: translate("Reason"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 160 }}>
            <PSelect
              options={reasonOptions}
              value={value.v}
              onChange={(event, newValue) =>
                updateData("table", tableMeta, { v: newValue })
              }
            ></PSelect>
          </div>
        ),
      },
    },
    /*{
      name: "status",
      label: translate("status"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div
            style={{
              width: 100,
              color:
                value.v === "PENDING"
                  ? "#055bfa"
                  : value.v === "IN-PROGRESS"
                  ? "#f0b802"
                  : value.v === "SUCESS"
                  ? "#05fa7f"
                  : "#ff3838",
            }}
          >
            {value.v}
          </div>
        ),
      },
    },*/
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: props.viewMode == "view" ? "false" : "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() => onRemoveItemClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("REMOVE")}
            </Button>
          </div>
        ),
      },
    },
  ];

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: getWindowDimensions().height - 400,
    rowsPerPage: Math.round((getWindowDimensions().height - 400) / 50),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 400) / 50),
      15,
      50,
      100,
    ],
  };

  function handleUploadData() {
    db.table("inventoryAdjBulkImport").clear();
    setOpenFileDropWindow(true);
  }

  async function handleFileProcess(data) {
    setItems(data);
    let dataForDb = [];
    for (let dataItem of data) {
      let saveObject = Object.create(null);
      saveObject["id"] = dataItem[5].info.barcode; //BARCODE as id
      saveObject["payload"] = dataItem;
      dataForDb.push(saveObject);
    }
    db.table("inventoryAdjBulkImport").bulkPut(dataForDb);
  }

  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td width="25%">{translate("Change Type")}</td>
              <td>
                <PSelect
                  options={stockChangeTypeOptions}
                  value={stockChangeType}
                  onChange={(event, newValue) => setStockChangeType(newValue)}
                ></PSelect>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td width="15%">{translate("Description")}</td>
              <td>
                <PText
                  value={description}
                  error={descriptionError}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setDescriptionError(null);
                  }}
                ></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={12}>
        <table width="100%">
          <tr>
            <td width="88%">
              <AsyncSelect
                formatOptionLabel={formatOptionLabel}
                components={{ formatOptionLabel }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  marginRight: "10px",
                }}
                placeholder={translate("Product Lookup")}
                loadOptions={getOptions}
                onChange={productLookupChanged}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                }}
                value={prodLookupValue}
              />
            </td>
            <td width="10%">
              <Button onClick={handleUploadData} color="primary">
                Bulk Import
              </Button>
            </td>
            <td width="2%">
              <Tooltip title={translate("Clear Cache")}>
                <IconButton
                  color="secondary"
                  onClick={() => {
                    db.table("inventoryAdjBulkImport").clear();
                    setItems([]);
                  }}
                >
                  <CachedIcon />
                </IconButton>
              </Tooltip>
            </td>
          </tr>
        </table>
      </Grid>
      <Grid item xs={12} sm={12}>
        <MUIDataTable data={items} columns={columns} options={options} />
      </Grid>
    </Grid>
  );
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"lg"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          saveLabel={saveLabel}
          isSaveLoaderEnabled={isSaveLoaderEnabled}
          saveDisabled={isSaveLoaderEnabled}
          onDelete={onDelete}
          mode={mode}
          showSaveDraftButton={true}
          onSaveDraftClicked={handleSaveDraftClicked}
        ></PDialog>
      )}
      <BulkImport
        handleFileProcess={handleFileProcess}
        openWindow={openFileDropWindow}
        setOpenWindow={setOpenFileDropWindow}
        showMessage={props.showMessage}
        productCache={props.productCache}
        maxSize={1}
        consolidateItems={true}
      ></BulkImport>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
